import React from 'react';
import './VenueDetails.css';

import { Heading } from '../../components';
import { venue } from '../../constants';


// VenueDetails component with optional reverse order
const VenueDetails = ({ reverseOrder = false }) => {

  const content = (

    // Venue Information Section
    <section className="custom-form venue-info linear-bg">
      <div className="box-container">
        <div className="content">
          <div className="text">

            <Heading title={venue.venueInfo.heading} subTitle={venue.venueInfo.sub} sideHeading linear />

            {/* Venue Info Points */}
            <ul className="venue-points">
              {venue.venueInfo.points.map((point, index) => (
                <li key={index}>
                  <div className="icon">{point.icon}</div>
                  <div className="text">
                    <h5>{point.title}</h5>
                    <p>{point.description}</p>
                  </div>
                </li>
              ))}
            </ul>

          </div>
        </div>
      </div>
    </section>
  );

  // Google Map Section
  const map = (
    <iframe
      src={venue.googleMap.src}
      style={{ border: 0 }}
      allowFullScreen={venue.googleMap.allowFullScreen}
      loading={venue.googleMap.loading}
      title="Venue Location"
    ></iframe>
  );

  return (
    <div className="venue-details">

      {/* Conditional Rendering: Map First or Content First */}
      {reverseOrder ? (
        <>
          {content} {/* Show Info First */}
          {map} {/* Show Map After */}
        </>
      ) : (
        <>
          {map} {/* Show Map First */}
          {content} {/* Show Info After */}
        </>
      )}

    </div>
  );
};

export default VenueDetails;